import React from 'react';
import { useSelector } from 'react-redux';
import { selectPathname } from 'store/Router/selectors';
import { selectVulnTemplateDetailId } from 'store/KnowledgeBase/selectors';
import { getEESelector } from 'Common/ee/registry';
import {
  Agents, AnalyticsGraphs, EditGraph, KbTitle, MCP,
  NewGraph, Notifications, NotificationsSettings, Planner, Reports,
  Scheduler,
  Users
} from './Titles';

const Title = () => {
  const pathname = useSelector((state) => selectPathname(state));
  const currentVulnTemplate = useSelector(selectVulnTemplateDetailId);
  const graphId = useSelector(getEESelector('analytics-graph-id', () => 0));
  const showKB = (pathname === '/knowledge_base') ||
  (pathname.includes('/knowledge_base/')) ||
  pathname === `/knowledge_base/${currentVulnTemplate}`;
  const analyticsList = pathname === '/analytics';
  const analyticsNew = pathname === '/analytics/new';
  const analyticsEdit = pathname === `/analytics/${graphId}`;
  const planner = pathname.startsWith('/planner');
  const reports = pathname.startsWith('/report') || pathname.startsWith('/legacy-report') || pathname.startsWith('/templates') || pathname.startsWith('/styles') || pathname.startsWith('/scope');
  // const reportsNew = pathname === '/report/new';
  // const reportsEdit = pathname.startsWith('/report/edit');
  const notifications = pathname === '/notifications-log';
  const notificationsSettings = pathname === '/notifications-settings';
  const agents = pathname === '/automation/agents';
  const cloudAgents = pathname === '/automation/cloud_agents';
  const agentExecutions = pathname === '/automation/agent_executions';
  const scheduler = (pathname === '/automation/schedule') || (pathname === '/automation/schedule_cloud');
  const users = pathname.startsWith('/users') || pathname.startsWith('/roles');
  const mcp = pathname === '/mcp';

  if (showKB) return <KbTitle />;
  if (analyticsList) return <AnalyticsGraphs />;
  if (analyticsNew) return <NewGraph />;
  if (analyticsEdit) return <EditGraph />;
  if (planner) return <Planner />;
  if (reports) return <Reports />;
  if (notifications) return <Notifications />;
  if (notificationsSettings) return <NotificationsSettings />;
  if (agents || cloudAgents || agentExecutions) return <Agents />;
  if (scheduler) return <Scheduler />;
  if (users) return <Users />;
  if (mcp) return <MCP />;
  return null;
};

export default Title;
